import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
const resources = {
  en: {
    translation: {
      common: {
        loading: "Loading...",
        error: "An error occurred",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        create: "Create",
        search: "Search",
        submit: "Submit",
        confirm: "Confirm",
        back: "Back"
      },
      auth: {
        signIn: "Sign In",
        signUp: "Sign Up",
        signOut: "Sign Out",
        email: "Email",
        password: "Password",
        forgotPassword: "Forgot password?",
        noAccount: "Don't have an account?",
        hasAccount: "Already have an account?"
      },
      navigation: {
        home: "Home",
        feed: "Feed",
        groups: "Groups",
        events: "Events",
        discover: "Discover",
        messages: "Messages",
        notifications: "Notifications",
        profile: "Profile",
        settings: "Settings",
        admin: "Admin"
      },
      settings: {
        account: "Account Settings",
        profile: "Profile Settings",
        privacy: "Privacy",
        notifications: "Notifications",
        language: "Language",
        theme: "Theme",
        security: "Security",
        accessibility: "Accessibility",
        deleteAccount: "Delete Account"
      },
      languages: {
        en: "English",
        es: "Español",
        fr: "Français",
        de: "Deutsch",
        it: "Italiano",
        pt: "Português",
        ja: "日本語",
        ko: "한국어",
        zh: "中文",
        ar: "العربية"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;